export default "__VITE_ASSET__opLiMGta__"